<template>
  <div class="header-container">
    <!-- 顶部 -->
    <el-row>
      <el-col>
        <div class="header">
          <div class="header-main">
            <div class="header-main-left">
              <i class="iconfont icon51 icon"></i>
              <a :href="baseLink" class="home-link">教习网 - 教育资源网站领跑者</a><span class="statistic">总资源：<span
                  class="docs-count">{{ moneyFomat(bckInfo.statistic_result) }}</span> 套</span><span
                class="statistic">24小时新增：<span class="docs-count">{{ moneyFomat(bckInfo.daily_statistic) }}</span>
                套</span><a :href="`${baseLink}article-5396.html`" target="_blank" title="兼职招聘" class="f60">兼职招聘</a>
            </div>
            <div class="header-main-right">
              <div class="user-dropdown" v-if="userInfo.user_id" @mouseover="show = true" @mouseout="show = false">
                <a :href="`${baseLink}user/home/`">{{ userInfo.nickname }}<i class="iconfont icon-arrow"
                    :class="show ? 'iconshang' : 'iconxia'"></i>
                </a>
                <div class="dropdown-list" v-show="show">
                  <div class="top">
                    <div class="left">
                      <div class="avatar">
                        <img :src="userInfo.avatar" v-if="userInfo.avatar" />
                        <img src="../assets/images/my_info_head.png" v-else />
                      </div>
                      <div class="user-wrap">
                        <div class="user-name">{{ userInfo.nickname }}</div>
                        <div class="user-id">ID:{{ userInfo.user_id }}</div>
                      </div>
                    </div>
                    <div class="right" @click="toLogout">
                      <a href="javascript:;">退出</a>
                    </div>
                  </div>
                  <div class="bot">
                    <a class="link" :href="`${baseLink}user/home/`">
                      <div class="icon user"></div>
                      <span class="text">个人中心</span>
                    </a>
                    <a class="link middle" :href="`${baseLink}user/recharges/`">
                      <div class="icon recharge"></div>
                      <span class="text">充值中心</span>
                    </a>
                    <a class="link" :href="`${baseLink}user/downloads/`">
                      <div class="icon download"></div>
                      <span class="text">我的下载</span>
                    </a>
                  </div>
                </div>
              </div>
              <template v-else>
                <a :href="`${baseLink}login`" rel="nofollow" title="登录">登录</a>
                <a class="register" :href="`${baseLink}register`" rel="nofollow" title="注册有礼">注册有礼</a>
              </template>
              <div class="bkc-home">
                <a class="bkc-link" :href="`${baseLink}jc/${bookId}/`" title="备课中心">备课中心</a>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 中间 -->
    <el-row>
      <el-col>
        <div class="nav">
          <div class="nav-main">
            <div class="website-logo">
              <a :href="baseLink">
                <img id="logo" src="../assets/images/logo_1.png" alt="教习网" title="教习网" width="140" height="46" />
              </a>
            </div>
            <div class="stage-subject-filters" @mouseenter="showFilters = true" @mouseleave="showFilters = false">
              <div class="titel-wrap">
                <span class="text">{{ stage.name }}·{{ subject.name }}</span>
                <span class="triangle" :class="showFilters ? 'top' : 'bot'"></span>
              </div>
              <transition name="fade">
                <div class="filters-list" v-show="showFilters">
                  <ul class="stage-wrap">
                    <li class="stage-item" v-for="(item, index) in filtersData" :key="item.id"
                      :class="index == on ? 'on' : ''">
                      <span class="text" @mouseenter="stageEnter(index)" @mouseleave="stageLeave">{{ item.name }}</span>
                    </li>
                    <li class="tab-scroll-bar" :style="{ left: scrollLeft }"></li>
                  </ul>
                  <div class="list-content" v-if="filtersData.length">
                    <ul class="subject-list">
                      <li class="subject-item" v-for="row in filtersData[on].children" :key="row.i"
                        :class="filtersData[on].id == stage.id && row.id == subject.id ? 'active' : ''"
                        @click="setFiltersInCookie(filtersData[on], row)">
                        <a target="_self" :href="`${baseLink}${row.href.substr(1)}?jump=paper`">{{ row.name }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
            <div class="search-form">
              <div class="form-left">
                <input type="text" v-model="searchKeyWord" id="serachText" maxlength="38" :placeholder="placeholder"
                  ref="input" @keyup.enter="submiteSearch" />
              </div>
              <div class="form-right">
                <span @click="submiteSearch">搜 索</span>
              </div>
            </div>
            <div class="upload-files">
              <a target="_blank" href="//upload.51jiaoxi.com"> <i class="iconfont iconshangchuan icon"></i>上传文档 </a>
              <span class="upload-tooltips">赚现金</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 导航 -->
    <el-row>
      <el-col>
        <div class="navigations-bar">
          <ul class="nav-inner">
            <li class="nav-item" v-for="item in navs" :key="item.id" @mouseenter="showSubMenus(item)"
              @mouseleave="hideSubMenus(item)">
              <a target="_self" :href="item.name == '组卷' ? item.href : `${baseLink}${item.href.substr(1)}`"
                :class="item.name == '组卷' ? 'nav_selected' : ''">
                {{ item.name }}
                <i class="iconfont" :class="item.isShow ? 'icon-shang' : 'icon-xia'" v-if="item.children.length"></i>
                <!-- <span v-if="item.name == '组卷'" class="free-icon"></span> -->
              </a>
              <transition name="show">
                <ul class="sub-nav-list" v-if="item.children.length" v-show="item.isShow">
                  <li class="sub-nav-item" v-for="row in item.children" :key="row.id">
                    <a target="_self" :href="`${baseLink}${row.href.substr(1)}`">{{ row.name }}</a>
                  </li>
                </ul>
              </transition>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var timer, that
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { userInfor, logout, shoppingCartList, getNavs, commonInfo } from '@/api/header'
import { paperBasicData } from '@/api/manual'
import * as util from '../utils/util.js'
export default {
  name: 'headerPage',
  data() {
    return {
      searchTypeList: [
        { label: '备课', value: 0 },
        { label: '试题', value: 2 },
      ],
      selectedText: '备课',
      placeholder: '搜索备课资料',
      searchUrl: '', // 试卷和备课的搜索页面地址
      searchType: 0, // 搜索类型
      searchKeyWord: '', // 搜索关键字

      showFilters: false,
      scrollLeft: '20px',
      on: 0,
      stage: {
        id: 1,
        name: '小学',
      },
      subject: {
        id: 2,
        name: '语文',
      },
      filtersData: [],
      navs: [],

      userInfo: {},
      bckInfo: {},
      show: false,
      bookId: 119480, // 默认值
    }
  },
  computed: {
    ...mapGetters(['baseLink']),
  },
  watch: {
    searchType(val) {
      if (val == 0) {
        that.searchUrl = `${that.baseLink}search`
      } else if (val == 1) {
        that.searchUrl = `${that.baseLink}papers/search`
      } else {
        that.searchUrl = ''
      }
    },
  },
  created() {
    that = this
    that.searchUrl = `${that.baseLink}search`
    // that.getUserInfor()
    // that.getBkcInfo()
    let stageId = util.getUrlKey('stage_id'),
      subjectId = util.getUrlKey('subject_id')
    if (stageId && subjectId) {
      that.stage.id = stageId
      that.subject.id = subjectId
      that.setFiltersInCookie(that.stage, that.subject)
    } else {
      if (Cookies.get('filters')) {
        let filters = Cookies.get('filters').split(',')
        if (filters[0]) {
          that.stage.id = filters[0]
        }
        if (filters[1]) {
          that.subject.id = filters[1]
        }
      }
    }
    if (util.getUrlKey('from')) {
      that.$root.Bus.$on('reloadStageAndSubject', obj => {
        that.stage.id = obj.st_id
        that.subject.id = obj.sub_id
        // that.getDefStageAndSubject()
      })
    } else {
      // that.getDefStageAndSubject()
    }
  },
  mounted() {
    let kw = util.getUrlKey('keyword')
    if (kw) {
      that.searchType = 2
      that.selectedText = '试题'
      that.searchKeyWord = kw
    }
    // that.getShoppingCartList()
    // 获取头部高度
    this.$store.dispatch('setHeaderHeightAnsy', document.querySelector('.header-container').offsetHeight)
  },
  methods: {
    moneyFomat(value) {
      if (value) {
        var pattern = /(?=((?!\b)\d{3})+$)/g
        return value.toString().replace(pattern, ',')
      }
    },
    getBkcInfo() {
      return new Promise((resolve, reject) => {
        commonInfo().then(res => {
          if (res.code == 200) {
            that.bckInfo = res.data
            that.setBkcLink()
          }
        })
      })
    },
    setBkcLink() {
      let localBookId = Cookies.get('bkc_book_id')
      if (localBookId) {
        that.bookId = localBookId
      }
      if (that.bckInfo.book_id) {
        that.bookId = that.bckInfo.book_id
      }
    },
    getUserInfor() {
      // 获取用户信息
      return new Promise((resolve, reject) => {
        userInfor()
          .then(res => {
            if (res.code == 200) {
              that.userInfo = res.data
              that.$store.dispatch('setUserInfoAnsy', res.data)
            }
          })
          .catch(err => {
            // 处理退出登录，通过浏览器返回导致可以进入到试卷编辑页面
            let uri = window.location.href
            if (err.code == 401 && uri.indexOf('paperFrontend/paperEdit') > -1) {
              util.locatioanToLogin(err)
            }
          })
      })
    },
    getShoppingCartList() {
      // 购物车列表
      return new Promise((resolve, reject) => {
        shoppingCartList().then(res => {
          if (res.code == 200) {
            that.shoppingCartList = res.data.shoppingCarts
            that.shoppingCartListNum = res.data.num
          }
        })
      })
    },
    toLogout() {
      // 退出登录
      return new Promise((resolve, reject) => {
        logout().then(res => {
          if (res.code == 200) {
            util.showTips(res.status)
            window.location.href = that.baseLink
          }
        })
      })
    },
    selectType(value) {
      switch (value) {
        case 0:
          that.placeholder = '搜索备课资料'
          that.selectedText = '备课'
          break
        case 1:
          that.placeholder = '搜索试卷'
          that.selectedText = '试卷'
          break
        case 2:
          that.placeholder = '搜索试题'
          that.selectedText = '试题'
          break
      }
      that.searchType = value
    },
    submiteSearch() {
      if (that.searchKeyWord) {
        if (that.searchType == 0) {
          window.location.href = that.searchUrl + '?keyword=' + that.searchKeyWord
        } else if (that.searchType == 1) {
          window.location.href = that.searchUrl + '?keyword=' + that.searchKeyWord
        } else {
          var searchUrl = `${that.baseLink}api/question/search?keyword=${that.searchKeyWord}&stage_id=${that.stage.id}&subject_id=${that.subject.id}`
          window.location.href = searchUrl
        }
      } else {
        that.$refs.input.focus()
      }
    },
    getNavs() {
      let params = {
        stage_id: that.stage.id,
        subject_id: that.subject.id,
      }
      return new Promise((resolve, reject) => {
        getNavs(params).then(res => {
          if (res.code === 200) {
            that.filtersData = res.data.nav
            res.data.links.forEach(item => {
              that.$set(item, 'isShow', false)
            })
            that.navs = res.data.links
            that.on = that.stage.id - 1
            that.stageEnter(that.on)
          }
        })
      })
    },
    getDefStageAndSubject() {
      let params = {
        stage_id: that.stage.id,
        subject_id: that.subject.id,
        version_id: '',
        book_id: '',
      }
      return new Promise((resolve, reject) => {
        paperBasicData(params).then(res => {
          if (res.code === 200) {
            that.stage = res.data.stages.find(item => {
              return item.choose == 1
            })
            that.subject = res.data.subjects.find(item => {
              return item.choose == 1
            })
            this.getNavs()
          }
        })
      })
    },
    stageEnter(i) {
      timer = setTimeout(function () {
        that.on = i
        switch (i) {
          case 0:
            that.scrollLeft = '20px'
            break
          case 1:
            that.scrollLeft = '95px'
            break
          case 2:
            that.scrollLeft = '170px'
            break
          default:
            that.scrollLeft = '20px'
            break
        }
      }, 200)
    },
    stageLeave() {
      clearTimeout(timer)
      timer = null
    },
    showSubMenus(row) {
      row.isShow = true
    },
    hideSubMenus(row) {
      row.isShow = false
    },
    setFiltersInCookie(stage, subject) {
      that.stage = { ...stage }
      that.subject = { ...subject }
      var str = that.stage.id + ',' + that.subject.id
      Cookies.set('filters', str, {
        expires: 7,
        path: '/',
        domain: that.$cookiesDomain,
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.header-container {
  max-width: 100%;

  .header {
    // 顶部
    height: 32px;
    background-color: #f2f2f2;

    &>.header-main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 1200px;
      min-width: 1200px;
      height: 100%;
      margin: 0 auto;
      font-size: 12px;
      color: #999;

      a {
        color: #999;
      }

      a:hover {
        color: #2b99ff;
      }

      .header-main-left {
        height: 32px;
        display: flex;
        align-items: center;

        .icon {
          font-size: 18px;
        }

        .home-link {
          margin-left: 4px;
          font-size: 12px;
        }

        .statistic {
          margin-right: 20px;

          .docs-count {
            color: #2b99ff;
          }
        }

        a {
          margin-right: 20px;
        }

        .f60 {
          color: #f60;
          font-weight: 600;
        }
      }

      .header-main-right {
        display: flex;
        align-items: center;

        .register {
          padding-left: 15px;
          color: #f60;
        }

        .user-dropdown {
          position: relative;
          min-width: 70px;
          height: 100%;
          text-align: center;

          &>a {
            display: inline-block;
            height: 32px;
            line-height: 30px;
            width: 100%;
            color: #999;

            &:hover {
              color: #2b99ff;
            }
          }

          .icon-arrow {
            position: relative;
            top: 2px;
            padding-left: 5px;
          }

          .dropdown-list {
            position: absolute;
            top: 32px;
            right: 0;
            width: 270px;
            height: 184px;
            border: 1px solid #eee;
            background: #fff;
            z-index: 10;
            box-shadow: 0px 8px 32px 16px rgba(175, 175, 175, 0.2);
            border-radius: 0px 0px 6px 6px;
            box-sizing: border-box;

            .top {
              height: 80px;
              background: url('../assets/images/bkc/user_dropdown.png');
              padding: 20px;
              overflow: hidden;
              box-sizing: border-box;

              .left {
                float: left;

                .avatar {
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  float: left;
                  margin-right: 8px;

                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                  }
                }

                .user-wrap {
                  float: right;
                  text-align: left;
                  line-height: 20px;

                  .user-name {
                    font-size: 14px;
                    color: #333;
                    font-weight: 600;
                    max-width: 150px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }

                  .user-id {
                    color: #999;
                  }
                }
              }

              .right {
                float: right;
                line-height: 22px;
              }
            }

            .bot {
              margin-top: 22px;
              text-align: center;

              .link {
                display: inline-block;
                width: 48px;
                text-align: center;

                &.middle {
                  margin: 0 30px;
                }

                .icon {
                  width: 48px;
                  height: 40px;
                  margin-bottom: 6px;
                  box-sizing: border-box;

                  &.user {
                    background: url(../assets/images/bkc/user.png) center no-repeat;
                  }

                  &.recharge {
                    background: url(../assets/images/bkc/recharge.png) center no-repeat;
                  }

                  &.download {
                    background: url(../assets/images/bkc/download.png) center no-repeat;
                  }
                }

                .text {
                  color: #333;
                }
              }
            }
          }
        }

        .bkc-home {
          width: 70px;
          height: 100%;
          color: #fff;
          line-height: 32px;
          text-align: center;
          background-color: #2b99ff;
          margin-left: 20px;

          .bkc-link {
            display: block;
            color: #fff;
          }
        }
      }
    }
  }

  .nav {
    // 菜单搜索部分
    width: 100%;
    height: 106px;
    background-color: #fff;

    &>.nav-main {
      display: flex;
      box-sizing: border-box;
      padding: 20px 0;
      width: 1200px;
      min-width: 1200px;
      height: 100%;
      margin: 0 auto;

      &>.website-logo {
        float: left;
        margin-top: 8px;
      }

      &>.stage-subject-filters {
        position: relative;
        margin: 0 60px 0 25px;
        width: 135px;
        line-height: 64px;
        cursor: pointer;

        .titel-wrap {
          display: flex;
          align-items: center;

          .text {
            font-size: 16px;
            color: #666;
          }

          .triangle {
            width: 0;
            height: 0;
            margin-left: 5px;
            border-style: solid;

            &.bot {
              border-width: 4px 4px 0 4px !important;
              border-color: #666 transparent transparent transparent;
            }

            &.top {
              border-width: 0 4px 4px 4px !important;
              border-color: transparent transparent #666 transparent;
            }
          }
        }

        .filters-list {
          position: absolute;
          left: 0;
          top: 50px;
          min-width: 264px;
          margin-left: -100px;
          background-color: #fff;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
          border-radius: 2px;
          z-index: 999999999;

          // display: none;
          a:hover {
            color: #2b99ff !important;
          }

          .stage-wrap {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 38px;
            border-bottom: 2px solid #eee;
            padding: 0 20px;
            box-sizing: border-box;

            .stage-item {
              position: relative;
              top: 1px;
              height: 100%;
              line-height: 36px;
              color: #000;
              font-weight: 600;
              font-size: 14px;
              flex: 1;
              text-align: center;
              cursor: pointer;

              &.on {
                .text {
                  color: #2b99ff;
                }
              }

              &>.text {
                display: inline-block;
                height: 100%;
              }
            }

            .tab-scroll-bar {
              position: absolute;
              left: 20px;
              bottom: -1px;
              height: 2px;
              border-bottom: 2px solid #2b99ff;
              transition: right 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1) 0.09s;
              width: 75px;
            }
          }

          .list-content {
            min-height: 80px;
            padding: 10px 20px;
            padding-right: 0;
            cursor: auto;

            .subject-list {
              width: 100%;
              height: 100%;
              overflow: hidden;
              display: none;

              &:nth-child(1) {
                display: block;
              }

              .subject-item {
                float: left;
                height: 20px;
                line-height: 20px;
                margin-bottom: 10px;
                margin-right: 14px;

                a {
                  color: #666;
                  font-size: 14px;
                }

                &.active {
                  a {
                    color: #2b99ff;
                  }
                }
              }
            }
          }
        }
      }

      &>.nav-list {
        float: left;
        list-style: none;
        margin: 0;
        padding: 0;
        margin-left: 60px;
        height: 100%;

        &>li {
          float: left;
          height: 100%;
          line-height: 60px;
          margin-right: 5px;
          padding: 0 10px;
          text-align: center;

          &>a {
            color: #092346;
            font-size: 16px;

            &:hover {
              color: #2b99ff;
            }
          }
        }
      }

      &>.search-form {
        position: relative;
        width: 500px;
        height: 40px;
        float: left;
        border: 2px solid #2b99ff;
        margin-top: 8px;
        box-sizing: border-box;
        border-radius: 6px;

        .form-left {
          height: 100%;
          width: 435px;
          border-radius: 6px;

          &>input {
            box-sizing: border-box;
            line-height: 34px;
            width: 70%;
            padding-left: 10px;
            float: left;
            outline: 0;
            border: none;
            font-size: 14px;
            height: 34px;
            margin-top: 1px;
            -webkit-box-shadow: 0 0 0px 1000px white inset;
            border-radius: 6px;

            &::-webkit-input-placeholder {
              color: #ccc;
            }
          }

          .search-type {
            position: relative;
            width: 68px;
            height: 100%;
            float: left;
            border: none;

            .search-text {
              box-sizing: border-box;
              line-height: 20px;
              display: inline-block;
              margin-top: 8px;
              padding: 0 9px;
              border-right: 1px solid #ccc;
              cursor: pointer;

              em {
                color: #333;
                font-size: 12px;
                font-style: normal;
              }

              i {
                display: inline-block;
                font-size: 14px;
                background-repeat: no-repeat;
                background-position: 85% 51%;
                margin-left: 4px;
                color: rgb(172, 172, 172);
              }
            }

            .form-search-list {
              position: absolute;
              top: 38px;
              left: 0;
              margin-left: -2px;
              margin-bottom: 0;
              width: 60px;
              background: #fff;
              border: 2px solid #2b99ff;
              border-top: 0;
              overflow: hidden;
              display: block;
              z-index: 9999;
              padding: 3px 0;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

              &>li {
                height: 20px;
                line-height: 22px;
                font-size: 12px;
                color: #666;
                cursor: pointer;
                padding-left: 8px;

                &:hover {
                  background-color: #f2f2f2;
                }
              }
            }
          }
        }

        .form-right {
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          height: 100%;

          span {
            display: block;
            background-color: #2b99ff;
            width: 100px;
            text-align: center;
            line-height: 36px;
            height: 100%;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }

      .upload-files {
        position: relative;
        display: inline-block;
        width: 116px;
        height: 40px;
        border: 2px solid #f60 !important;
        text-align: center;
        margin-left: 60px;
        margin-top: 8px;
        vertical-align: top;
        border-radius: 4px;
        box-sizing: border-box;

        a {
          display: inline-block;
          width: 100%;
          height: 36px;
          line-height: 36px;
          font-size: 16px;
          color: #f60;

          &:hover {
            background-color: #fffbf1;
          }
        }

        .upload-tooltips {
          position: absolute;
          top: -10px;
          left: 80px;
          color: #fff;
          font-size: 12px;
          border-radius: 2px;
          text-align: center;
          width: 44px;
          height: 17px;
          line-height: 18px;
          background-color: #f60;

          &::after {
            position: absolute;
            content: ' ';
            border-width: 3px 0 3px 3px;
            display: block;
            width: 0;
            height: 0;
            border-color: transparent transparent transparent #f60;
            border-style: solid;
            top: 13px;
            margin-left: -3px;
            left: 3px;
          }
        }
      }
    }
  }

  .navigations-bar {
    width: 100%;
    height: 40px;
    background-color: #2b99ff;

    .nav-inner {
      width: 1200px;
      height: 100%;
      max-width: 1200px;
      margin: 0 auto;

      .nav-item {
        float: left;
        height: 100%;
        margin-right: 10px;
        position: relative;

        &>a {
          line-height: 42px;
          display: inline-block;
          height: 100%;
          padding: 0 20px;
          color: #fff;
          font-size: 15px;

          &:hover,
          &.nav_selected {
            background-color: #067ff3;
          }

          &>i {
            font-size: 14px;
            vertical-align: middle;
            margin-left: 3px;
          }

          .free-icon {
            position: absolute;
            right: -12px;
            top: 4px;
            background: url('../assets/images/free_icon.png') no-repeat center;
            display: inline-block;
            width: 30px;
            height: 18px;
            animation: icon-float 1.8s infinite;
          }

          @keyframes icon-float {
            0% {
              top: 4px;
            }

            50% {
              top: -2px;
            }

            100% {
              top: 4px;
            }
          }
        }

        .sub-nav-list {
          position: absolute;
          top: 40px;
          left: 0;
          margin-left: -50px;
          background-color: #fff;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
          border-radius: 2px;
          width: 200px;
          padding: 20px 0;
          z-index: 9999999;
          overflow: hidden;

          .sub-nav-item {
            float: left;
            width: 82px;
            margin-left: 16px;

            &:nth-child(2n + 1) {
              border-right: 1px dashed #eee;
            }

            &:hover>a,
            &.active>a {
              color: #2b99ff;
            }

            &>a {
              line-height: 30px;
              display: inline-block;
              width: 100%;
              color: #333;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.el-popper.userdata-list {
  // 用户名下拉
  min-width: 100px;
  margin-top: 0 !important;
  padding: 0;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    min-width: 100px;
    margin-top: 0;

    li {
      list-style: none;
      line-height: 26px;
      text-align: center;
      margin: 0;
      outline: none;
      padding: 0 10px;

      &:first-child {
        margin-top: 10px;
      }

      &:last-child {
        margin-bottom: 10px;
      }

      &:hover {
        background-color: #fafafa;
      }

      &:hover>a {
        color: #2b99ff;
      }

      a {
        font-size: 14px;
        color: grey;
      }
    }
  }
}

.el-popper.shopping-cart-popover {
  // 购物车下拉
  box-sizing: border-box;
  position: relative;
  padding: 0;

  .shopping-cart-slot {
    width: 100%;

    &>ul {
      margin: 0;
      padding: 0;
      list-style: none;
      padding: 10px;
      margin-bottom: 40px;
      height: 195px;

      &>li {
        list-style: none;
        padding: 5px 0;
        border-bottom: 1px solid #ddd;
        box-sizing: border-box;

        &>i {
          display: inline-block;
          width: 20px;
          height: 24px;
        }

        &>i.file-type-ppt {
          background: url(../assets/images/file/ppt.png) no-repeat center;
        }

        &>i.file-type-doc {
          background: url(../assets/images/file/doc.png) no-repeat center;
        }

        &>i.file-type-fold {
          background: url(../assets/images/file/fold.png) no-repeat center;
        }

        &>i.file-type-img {
          background: url(../assets/images/file/img.png) no-repeat center;
        }

        &>i.file-type-mp3 {
          background: url(../assets/images/file/mp3.png) no-repeat center;
        }

        &>i.file-type-others {
          background: url(../assets/images/file/others.png) no-repeat center;
        }

        &>i.file-type-pdf {
          background: url(../assets/images/file/pdf.png) no-repeat center;
        }

        &>i.file-type-rar {
          background: url(../assets/images/file/rar.png) no-repeat center;
        }

        &>i.file-type-video {
          background: url(../assets/images/file/video.png) no-repeat center;
        }

        &>a {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 80%;
          height: 24px;
          line-height: 24px;
          padding-left: 10px;
          color: #4d4d4d;
        }
      }
    }

    .empty-wrap {
      width: 100%;
      height: 160px;

      p {
        width: 100%;
        height: 100%;
        line-height: 120px;
        text-align: center;
        margin: 0;
        color: #ccc;
      }
    }

    &>.shopping-cart-footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
      background-color: #f2f2f2;

      &>* {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }

      &>span {
        float: left;
        padding: 0 10px;
        color: gray;
      }

      &>a {
        float: right;
        color: #fff;
        background-color: red;
        padding: 0 19px;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.1s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
